import * as rd from '@devexperts/remote-data-ts'
import { CartSliceState } from '@/store/cartSlice/type.ts'

export const selectCartDetailTotalPrice = (state: CartSliceState) => {
  if (!rd.isSuccess(state.cartDetailResponse)) return 0

  return state.cartDetailResponse.value.cart.totalPrice
}
